module.exports = (__webpack_require__("/BaM"))("fPh+");